import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/registration_status', component: List, name: 'registration_status.index'},
  {path: '/registration_status/store', component: Form, name: 'registration_status.store'},
  {path: '/registration_status/:id', component: Form, name: 'registration_status.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/registration_status/routes.js